'use client';

import React from 'react';

export default function AboutSection() {
  return (
    <section id="about" className="py-28 bg-cream-light relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 gap-16 items-center">
          {/* Right — Content */}
          <div>
            <div className="flex items-center gap-3 mb-6">
              <div className="h-px w-10 bg-gold" />
              <span className="text-gold text-xs tracking-[0.3em] uppercase font-light">Our Story</span>
            </div>
            <h2 className="font-serif text-navy-dark text-4xl md:text-5xl font-light leading-tight mb-6">
              An Elite World of{' '}
              <span className="italic text-primary">Cruising</span>
            </h2>
            <p className="text-navy-dark/60 font-light leading-relaxed mb-6 text-lg">
              The Ultra Luxury Cruise Club was born from a simple belief: that extraordinary experiences should be accessible to those who seek them — without compromise on quality or value.
            </p>
            <p className="text-navy-dark/50 font-light leading-relaxed mb-10">
              Join us on an extraordinary journey where luxury meets adventure. Whether you have questions about our voyages or want to explore exclusive membership benefits, we are here to assist you. Let&apos;s make unforgettable memories together.
            </p>

            {/* Values */}
            <div className="grid grid-cols-2 gap-4">
              {[
              { title: 'Curated Selection', desc: 'Only the finest ultra luxury cruise lines' },
              { title: 'Guaranteed Savings', desc: 'Exclusive members only discount, every booking' },
              { title: 'Personal Service', desc: 'Dedicated support from our travel experts' },
              { title: 'No Hidden Fees', desc: 'Free membership, transparent pricing' }]?.
              map((item) =>
              <div key={item?.title} className="p-4 bg-white border border-cream-dark rounded-sm">
                  <div className="w-1 h-4 bg-gold rounded-full mb-3" />
                  <div className="font-medium text-navy-dark text-sm mb-1">{item?.title}</div>
                  <div className="text-navy-dark/40 text-xs font-light">{item?.desc}</div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>);

}